import PhoneInput from 'react-phone-number-input';
import { FC, useMemo, useState } from 'react';
import 'react-phone-number-input/style.css';
import { CountryCode, E164Number } from 'libphonenumber-js/core';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'hooks';

import './phoneField.scss';
import '../SelectField/index.scss';

type PhoneFieldProps = {
	onChange?: (value?: E164Number | undefined) => void;
	value?: E164Number;
	country?: CountryCode;
	isSettings?: boolean;
	label?: string;
};

export const PhoneField: FC<PhoneFieldProps> = ({
	onChange,
	value,
	isSettings,
	label = 'phoneNumberText',
	country,
}) => {
	const [focus, setFocus] = useState(false);

	const { t } = useTranslation();

	const countries = useAppSelector((state) => state.settings.globals.countries);

	const countriesList = useMemo(
		() =>
			countries?.map((i: any) => {
				return {
					iso: i.iso,
					label: i.label,
				};
			}) || [],
		[countries],
	);

	const onChangePhone = (v: E164Number | undefined) => {
		if (onChange) {
			onChange(v);
		}
	};

	return (
		<div className="phoneField">
			<PhoneInput
				numberInputProps={{ id: 'phone' }}
				countrySelectProps={{ unicodeFlags: true }}
				international
				value={value}
				onBlur={() => setFocus(false)}
				onFocus={() => setFocus(true)}
				defaultCountry={country}
				withCountryCallingCode
				onChange={onChangePhone}
				countrySelectComponent={
					isSettings
						? () => <></>
						: ({ onChange, value }) => {
								return (
									<div className="countrySelect">
										<div className="countrySelect__value">
											<span>{value}</span>
										</div>
										<select
											name="country_name"
											className="mobileSelect"
											value={value}
											onChange={(e) => {
												onChange(e.target.value);
											}}
										>
											<option value="" defaultChecked hidden />
											{countriesList.map((item) => (
												<option key={item.iso} value={item.iso}>
													{item.label}
												</option>
											))}
										</select>
									</div>
								);
						  }
				}
			/>
			<span
				className={cn('phoneField__label', {
					'phoneField__label--settings': isSettings,
					'phoneField__label--focused': focus || (value && value.length !== 0),
				})}
			>
				{t(label)}
			</span>
		</div>
	);
};
